import { OssApi } from "../apis/Oss";
import { OssSceneValue } from "../global/OssConfig";

export class AliOssUtil {
    static async uploadFile(file: File, scene: OssSceneValue): Promise<string> {
        const ext = file.name.split(".").pop() || "jpg";
        const contentType = file.type || mimeOf(ext);
        const ticket = await OssApi.getUploadTicket({
            scene,
            ext,
            contentType,
        });
        if (!ticket || !ticket.uploadUrl || !ticket.accessUrl) {
            throw new Error("获取上传凭证失败");
        }
        const headers: Record<string, string> = {
            ...(ticket.headers || {}),
            "Content-Type": contentType,
        };
        const response = await fetch(ticket.uploadUrl, {
            method: "PUT",
            headers,
            body: file,
        });
        if (!response.ok) {
            throw new Error(`文件上传失败: ${response.status}`);
        }
        // 访问地址必须是无签名的公开 URL；防止误用上传预签名地址
        return ticket.accessUrl.split("?")[0];
    }

    static async uploadImageFromUrl(imageUrl: string, scene: OssSceneValue): Promise<string> {
        const response = await fetch(imageUrl);
        if (!response.ok) {
            throw new Error(`获取图片失败: ${response.status}`);
        }
        const blob = await response.blob();
        const file = new File([blob], "image.jpg", { type: blob.type || "image/jpeg" });
        return AliOssUtil.uploadFile(file, scene);
    }

    static async uploadImageFromClipboard(scene: OssSceneValue): Promise<string> {
        const items = await navigator.clipboard.read();
        for (const item of items) {
            if (item.types.includes("image/png") || item.types.includes("image/jpeg")) {
                const blob = await item.getType("image/png");
                const file = new File([blob], "clipboard-image.png", { type: "image/png" });
                return AliOssUtil.uploadFile(file, scene);
            }
        }
        throw new Error("剪贴板中没有图片");
    }
}

function mimeOf(ext: string): string {
    const value = ext.replace(".", "").toLowerCase();
    if (value === "jpg" || value === "jpeg") return "image/jpeg";
    if (value === "png") return "image/png";
    if (value === "gif") return "image/gif";
    if (value === "webp") return "image/webp";
    if (value === "mp4") return "video/mp4";
    if (value === "pdf") return "application/pdf";
    return "application/octet-stream";
}
